import type { DefectCount } from '@visionqc/shared';

/**
 * What operators actually found, ranked — horizontal bars.
 *
 * Horizontal because defect names are prose ("Hairline scratch"), and a ranked
 * magnitude reads best against a text column. Every bar is direct-labelled, so
 * the defect's own colour is decoration that ties back to the annotator, never
 * the thing carrying identity.
 */
export function DefectBars({ defects }: { defects: DefectCount[] }) {
  if (defects.length === 0) {
    return (
      <div className="muted" style={{ padding: '20px 0' }}>
        No defects recorded in this window — label some images on Annotate.
      </div>
    );
  }
  const max = Math.max(...defects.map((d) => d.count));

  return (
    <div className="grid" style={{ gap: 10 }}>
      {defects.map((d) => (
        <div key={`${d.defectTypeId}-${d.name}`}>
          <div className="row" style={{ justifyContent: 'space-between', marginBottom: 4 }}>
            {/* Text wears ink tokens, not the data colour. */}
            <span className="row" style={{ gap: 8, fontSize: 14 }}>
              <span
                style={{ width: 12, height: 12, borderRadius: 3, background: d.color, flex: 'none' }}
              />
              {d.name}
            </span>
            <strong style={{ fontFamily: 'var(--mono)', fontSize: 14 }}>{d.count}</strong>
          </div>
          <div style={{ background: 'var(--bg)', borderRadius: 4, height: 10 }}>
            <div
              style={{
                width: `${(d.count / max) * 100}%`,
                height: '100%',
                background: d.color,
                // 4px rounded data-end, square at the baseline
                borderRadius: '0 4px 4px 0',
                minWidth: 4,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
